/* MCH Theme JS — optimized */
(function() {
  'use strict';

  /* ===== Hydrate config from JSON island (set up in layout/theme.liquid).
     Runs at file parse time (defer preserves script order), so downstream
     scripts like cart-drawer.js still see window.MCH_SHIPPING/MCH_I18N. ===== */
  (function hydrateMchConfig() {
    try {
      var el = document.getElementById('mch-config');
      if (!el) return;
      var cfg = JSON.parse(el.textContent || '{}');
      if (cfg.shipping) window.MCH_SHIPPING = cfg.shipping;
      if (cfg.i18n)     window.MCH_I18N     = cfg.i18n;
    } catch (e) {
      /* Malformed JSON — leave globals undefined; consumers already fall back. */
    }
  })();

  /* ===== Shared HTML escape ===== */
  window.mchEscape = function(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  };

  document.addEventListener('DOMContentLoaded', function() {

    /* ===== COOKIE CONSENT BANNER (Shopify Customer Privacy API).
       First-visit visitors see the banner; choice is persisted in localStorage
       under `mch_consent` ('all' | 'essential') and mirrored to Shopify's
       customerPrivacy.setTrackingConsent so analytics/marketing pixels respect
       it. If the API isn't loaded (rare), we still persist the choice locally. ===== */
    (function mchConsentInit() {
      var banner = document.getElementById('mchConsent');
      if (!banner) return;
      var STORAGE = 'mch_consent';
      var prior;
      try { prior = localStorage.getItem(STORAGE); } catch (e) {}
      if (prior) { applyServerConsent(prior); return; }
      banner.hidden = false;
      banner.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-consent]');
        if (!btn) return;
        var choice = btn.dataset.consent;
        try { localStorage.setItem(STORAGE, choice); } catch (e) {}
        applyServerConsent(choice);
        banner.hidden = true;
      });
      function applyServerConsent(choice) {
        var accept = choice === 'all';
        var payload = {
          analytics: accept,
          marketing: accept,
          preferences: accept,
          sale_of_data: accept
        };
        try {
          if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent(payload, function(){});
          } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err) {
              if (err || !window.Shopify.customerPrivacy) return;
              window.Shopify.customerPrivacy.setTrackingConsent(payload, function(){});
            });
          }
        } catch (e) {}
      }
    })();

    /* ===== WEB VITALS REPORTER.
       Native PerformanceObserver — no deps. Captures LCP, CLS, INP + TTFB and
       publishes via `Shopify.analytics.publish('web_vitals', {...})` when the
       page is being unloaded (visibilitychange → hidden is the recommended
       signal per web.dev). If a Shopify customer-events pixel is installed
       (Shopify admin → Settings → Customer events → Add pixel), it receives
       these events. If not, the publish call is a no-op — zero harm.

       LCP: last entry before user interaction is final.
       CLS: sum of session-window layout shifts.
       INP: slowest interaction-to-paint (replaces FID in Core Web Vitals). ===== */
    (function mchWebVitals() {
      if (!('PerformanceObserver' in window)) return;
      var vitals = { lcp: null, cls: 0, inp: null, ttfb: null };

      // TTFB from the navigation timing entry (already buffered).
      try {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav) vitals.ttfb = Math.round(nav.responseStart - nav.requestStart);
      } catch (e) {}

      function observe(type, cb) {
        try {
          var po = new PerformanceObserver(function(list) { list.getEntries().forEach(cb); });
          po.observe({ type: type, buffered: true });
          return po;
        } catch (e) { return null; }
      }

      // LCP — keep the latest entry; the actual LCP is the last before input.
      observe('largest-contentful-paint', function(e) { vitals.lcp = Math.round(e.renderTime || e.loadTime || e.startTime); });

      // CLS — sum session-window shifts (hadRecentInput excludes user-triggered).
      observe('layout-shift', function(e) { if (!e.hadRecentInput) vitals.cls += e.value; });

      // INP — track the worst interaction latency.
      var worstInp = 0;
      observe('event', function(e) {
        if (e.interactionId && e.duration > worstInp) {
          worstInp = e.duration;
          vitals.inp = Math.round(worstInp);
        }
      });

      function report() {
        if (!report.fired) {
          report.fired = true;
          try {
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              window.Shopify.analytics.publish('web_vitals', {
                lcp: vitals.lcp, cls: Math.round(vitals.cls * 1000) / 1000,
                inp: vitals.inp, ttfb: vitals.ttfb,
                url: location.pathname, template: document.body.className
              });
            }
          } catch (e) {}
        }
      }
      // visibilitychange is the recommended single firing point.
      document.addEventListener('visibilitychange', function() { if (document.visibilityState === 'hidden') report(); });
      // pagehide fallback for browsers where visibilitychange isn't reliable on bfcache.
      addEventListener('pagehide', report);
    })();

    /* ===== MARQUEE ADAPTIVE FILL.
       The announcement bar seeds one copy of the blocks from Liquid. We clone
       children until the track is ≥ 2 × the bar's visible width, then set
       --mb-copies on the track so the keyframe (translateX(-100% / copies))
       moves by exactly one copy's width per cycle. Result: seamless loop
       regardless of how few blocks or how short the text is. Re-runs on
       debounced resize (breakpoints, orientation). ===== */
    (function mchMarqueeInit() {
      var bar = document.querySelector('.marquee-bar--marquee');
      if (!bar) return; // Only the scrolling variant needs this; rotate/static don't.
      var track = bar.querySelector('.marquee-track');
      if (!track) return;

      var seed = Array.prototype.slice.call(track.children);
      if (seed.length === 0) return;

      function fill() {
        // Reset to seed so resizes can both grow and shrink the track.
        while (track.children.length > seed.length) track.removeChild(track.lastChild);
        track.style.setProperty('--mb-copies', '1');

        var target = bar.offsetWidth * 2;
        if (target <= 0) return; // Hidden bar (e.g. display:none at breakpoint).
        var copies = 1;
        // Cap clones to avoid pathological layouts (empty bar + missing CSS).
        while (track.offsetWidth < target && copies < 32) {
          seed.forEach(function(node) {
            track.appendChild(node.cloneNode(true));
          });
          copies++;
        }
        track.style.setProperty('--mb-copies', String(copies));
      }

      fill();
      var t;
      addEventListener('resize', function() {
        clearTimeout(t);
        t = setTimeout(fill, 150);
      }, { passive: true });
    })();

    /* ===== NAVIGATION PREFETCH FALLBACK (Firefox / Safari).
       Chromium honors the Speculation Rules in theme.liquid and ignores this.
       For everyone else: on hover/focus of a product or collection link,
       append a <link rel="prefetch"> so the next navigation is warm. Skipped
       on Save-Data connections and limited to 12 prefetches per page. ===== */
    (function navPrefetch() {
      if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
      var nav = navigator.connection || {};
      if (nav.saveData) return;
      var prefetched = Object.create(null);
      var budget = 12;
      function warm(url) {
        if (budget <= 0 || prefetched[url]) return;
        try {
          var u = new URL(url, location.origin);
          if (u.origin !== location.origin) return;
          if (!/^\/(products|collections)\//.test(u.pathname)) return;
          prefetched[url] = true;
          budget--;
          var link = document.createElement('link');
          link.rel = 'prefetch';
          link.as = 'document';
          link.href = u.pathname + u.search;
          document.head.appendChild(link);
        } catch (e) {}
      }
      function handler(e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (a && a.href) warm(a.href);
      }
      document.addEventListener('pointerover', handler, { passive: true });
      document.addEventListener('focusin', handler);
    })();

    /* ===== STICKY HEADER ===== */
    var header = document.querySelector('.site-header');
    if (header) {
      var scrolledState = false;
      window.addEventListener('scroll', function() {
        var shouldBe = window.pageYOffset > 60;
        if (shouldBe !== scrolledState) {
          scrolledState = shouldBe;
          header.classList.toggle('scrolled', shouldBe);
        }
      }, {passive: true});
    }

    /* ===== MOBILE MENU ===== */
    var toggle = document.querySelector('.menu-toggle');
    var nav = document.querySelector('.main-nav');
    if (toggle && nav) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', function() {
        nav.classList.toggle('open');
        var isOpen = nav.classList.contains('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.classList.toggle('is-active', isOpen);
      });
    }

    /* ===== HEADER SEARCH TOGGLE ===== */
    var searchBtn = document.querySelector('.header-search-toggle');
    var searchForm = document.querySelector('.header-search-form');
    if (searchBtn && searchForm) {
      searchBtn.addEventListener('click', function() {
        var open = searchForm.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = searchForm.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchForm.classList.contains('is-open')) {
          searchForm.classList.remove('is-open');
          searchBtn.setAttribute('aria-expanded', 'false');
          searchBtn.focus();
        }
      });
    }

    /* ===== SLIDESHOW ===== */
    var slideshow = document.querySelector('.slideshow');
    if (slideshow) {
      var track = slideshow.querySelector('.slideshow__track');
      var slides = slideshow.querySelectorAll('.slideshow__slide');
      var dots = slideshow.querySelectorAll('.slideshow__dot');
      var prevBtn = slideshow.querySelector('.slideshow__arrow--prev');
      var nextBtn = slideshow.querySelector('.slideshow__arrow--next');
      var current = 0, total = slides.length, interval;
      function goTo(i) {
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        current = i;
        if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, idx) { d.classList.toggle('active', idx === current); });
      }
      function tick() { if (!document.hidden) goTo(current + 1); }
      function start() { clearInterval(interval); interval = setInterval(tick, 4500); }
      function stop() { clearInterval(interval); interval = null; }
      function reset() { if (!document.hidden) start(); }
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); reset(); });
      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); reset(); });
      dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); reset(); }); });
      var touchX = 0;
      slideshow.addEventListener('touchstart', function(e) { touchX = e.changedTouches[0].screenX; }, {passive:true});
      slideshow.addEventListener('touchend', function(e) {
        var diff = touchX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) { diff > 0 ? goTo(current+1) : goTo(current-1); reset(); }
      }, {passive:true});
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) stop(); else start();
      });
      if (total > 1) start();
    }

    /* ===== CART PAGE QTY CONTROLS ===== */
    var cartForm = document.querySelector('.cart-page form[action^="/cart"]');
    if (cartForm) {
      var cartSubmitTimer = null;
      cartForm.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-qty-action]');
        if (!btn) return;
        var input = btn.parentNode.querySelector('input[type="number"]');
        if (!input) return;
        var cur = parseInt(input.value, 10) || 0;
        var next = btn.dataset.qtyAction === 'plus' ? cur + 1 : Math.max(0, cur - 1);
        input.value = next;
        clearTimeout(cartSubmitTimer);
        cartSubmitTimer = setTimeout(function() { cartForm.submit(); }, 350);
      });
      cartForm.addEventListener('change', function(e) {
        if (e.target.matches('input[name="updates[]"]')) {
          clearTimeout(cartSubmitTimer);
          cartSubmitTimer = setTimeout(function() { cartForm.submit(); }, 350);
        }
      });
    }

    /* ===== QUICK ADD — Event Delegation ===== */
    function addToCartAjax(vid, btn, origText, resetCallback) {
      var i18n = (window.MCH_I18N && window.MCH_I18N.cart) || {};
      btn.textContent = i18n.adding || '…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) {
          return r.json().then(function() {
            btn.textContent = i18n.out_of_stock || 'Rasprodato';
            btn.classList.add('is-error');
            setTimeout(function() {
              btn.textContent = origText;
              btn.classList.remove('is-error');
              btn.disabled = false;
              if (resetCallback) resetCallback();
            }, 2000);
            throw new Error('skip');
          });
        }
        return r.json();
      })
      .then(function(item) {
        btn.textContent = '\u2713';
        btn.classList.add('added');
        if (window.dispatchEvent) window.dispatchEvent(new CustomEvent('cart:item-added', { detail: item }));
        setTimeout(function() {
          btn.textContent = origText;
          btn.classList.remove('added');
          btn.disabled = false;
          if (resetCallback) resetCallback();
        }, 1500);
      })
      .catch(function(e) {
        if (e && e.message === 'skip') return;
        btn.textContent = origText;
        btn.disabled = false;
      });
    }

    // Single delegated listener for ALL product card interactions
    document.addEventListener('click', function(e) {
      // Direct add (no variants)
      var directBtn = e.target.closest('.product-card__quick-add:not(.js-quick-add-trigger)');
      if (directBtn && !directBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var vid = directBtn.dataset.variantId;
        if (vid) {
          var i18n = (window.MCH_I18N && window.MCH_I18N.cart) || {};
          addToCartAjax(vid, directBtn, i18n.add_short || 'Dodaj', null);
        }
        return;
      }

      // Trigger size picker
      var trigger = e.target.closest('.js-quick-add-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = trigger.closest('.product-card__add-wrap');
        var sizesWrap = wrap ? wrap.querySelector('.product-card__sizes') : null;
        if (sizesWrap) {
          trigger.hidden = true;
          sizesWrap.hidden = false;
        }
        return;
      }

      // Size button click
      var sizeBtn = e.target.closest('.product-card__size-btn');
      if (sizeBtn && !sizeBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var vid2 = sizeBtn.dataset.variantId;
        if (!vid2) return;
        var origText = sizeBtn.textContent;
        var wrap2 = sizeBtn.closest('.product-card__add-wrap');
        var trig = wrap2 ? wrap2.querySelector('.js-quick-add-trigger') : null;
        addToCartAjax(vid2, sizeBtn, origText, function() {
          var sizes = sizeBtn.closest('.product-card__sizes');
          if (sizes) sizes.hidden = true;
          if (trig) trig.hidden = false;
        });
        return;
      }

      // Close size pickers when clicking outside
      if (!e.target.closest('.product-card__add-wrap')) {
        document.querySelectorAll('.product-card__sizes:not([hidden])').forEach(function(s) {
          s.hidden = true;
          var w = s.closest('.product-card__add-wrap');
          if (w) {
            var b = w.querySelector('.js-quick-add-trigger');
            if (b) b.hidden = false;
          }
        });
      }
    });

    // Touch close for mobile
    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('.product-card__add-wrap')) {
        document.querySelectorAll('.product-card__sizes:not([hidden])').forEach(function(s) {
          s.hidden = true;
          var w = s.closest('.product-card__add-wrap');
          if (w) {
            var b = w.querySelector('.js-quick-add-trigger');
            if (b) b.hidden = false;
          }
        });
      }
    }, {passive: true});

    // Expose for dynamic content (recently viewed)
    window.mchAddToCartAjax = addToCartAjax;
  });
})();
